<template>
  <div id="pages">
    <form v-if="!loading">
      <div class="vx-row mb-4">
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <vs-input
            class="inputx"
            name="contractTitle"
            :label="$t('Title')"
            v-model="contractDetails.title"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('contractTitle')"
            >{{ errors.first("contractTitle") }}</span
          >
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <label class="vs-select--label">{{ $t("ContractType") }}</label>
          <v-select
            label="name"
            name="cType"
            :options="contractType"
            v-model="contractDetails.salesType"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            dir="rtl"
            class="mb-2"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('cType')">{{
            errors.first("cType")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <label class="vs-select--label datepicker-lb">{{
            $t("StartDate")
          }}</label>
          <date-picker
            v-model="contractDetails.startClock"
            format="jYYYY-jMM-jDD"
            display-format="jYYYY-jMM-jDD"
            class="date-picker mb-2"
            :label="$t('StartDate')"
            name="startDate"
            v-validate="{ required: true }"
          />
          <span class="text-danger text-sm" v-show="errors.has('startDate')">{{
            errors.first("startDate")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <label class="vs-select--label datepicker-lb">{{
            $t("EndDate")
          }}</label>
          <date-picker
            v-model="contractDetails.expireClock"
            format="jYYYY-jMM-jDD"
            display-format="jYYYY-jMM-jDD"
            class="date-picker mb-2"
            :label="$t('EndDate')"
            name="endDate"
            v-validate="{ required: true }"
          />
          <span class="text-danger text-sm" v-show="errors.has('endDate')">{{
            errors.first("endDate")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <label class="vs-select--label">{{ $t("ToleranceType") }}</label>
          <v-select
            label="title"
            name="toleranceType"
            :options="toleranceTypes"
            v-model="contractDetails.reductionIncrease.toleranceType"
            :reduce="(x) => x.id"
            class="w-full"
            v-validate="{
              required:
                contractDetails.reductionIncrease.allowedReduction ||
                contractDetails.reductionIncrease.allowedIncrease
                  ? true
                  : false,
            }"
            dir="rtl"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('toleranceType')"
          >
            {{ errors.first("toleranceType") }}
          </span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <vs-input
            class="inputx"
            v-model="contractDetails.reductionIncrease.allowedReduction"
            name="allowedReduction"
            :label="$t('AllowedReduction')"
            v-validate="{
              required: contractDetails.reductionIncrease.toleranceType
                ? true
                : false,
            }"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('allowedReduction')"
          >
            {{ errors.first("allowedReduction") }}
          </span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <vs-input
            class="inputx"
            v-model="contractDetails.reductionIncrease.allowedIncrease"
            name="allowedIncrease"
            :label="$t('AllowedIncrease')"
            v-validate="{
              required: contractDetails.reductionIncrease.toleranceType
                ? true
                : false,
            }"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('allowedIncrease')"
          >
            {{ errors.first("allowedIncrease") }}
          </span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <vs-input
            class="inputx mb-2"
            :label="$t('ValueAddedTax')"
            v-model="contractDetails.valueAddedTax"
            name="tax"
            v-validate="{ regex: '^([0-9]+)$' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('tax')">{{
            errors.first("tax")
          }}</span>
        </div>

        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <label class="vs-select--label">{{ $t("ContractState") }}</label>
          <v-select
            label="name"
            name="cState"
            :options="contractState"
            v-model="contractDetails.contractState"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            dir="rtl"
            class="mb-2"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('cState')">{{
            errors.first("cState")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 mt-2 w-full">
          <vs-input
            class="inputx mb-2"
            :label="$t('ContractId')"
            disabled
            v-model="contractId"
            name="ContractId"
          />
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 lg:w-1/6 w-full">
          <div class="uploader-box">
            <my-upload
              field="img"
              @crop-success="cropSuccess"
              v-model="showUploader"
              :width="100"
              :height="100"
              langType="fa"
              :noCircle="true"
              img-format="jpg"
            ></my-upload>
            <img v-bind:src="contractDetails.logoImage" />
            <img
              :src="
                URLS_CONSTANTS.assets +
                'ContractLogo/' +
                contractDetails.logoUrl
              "
              v-if="contractDetails.logoUrl"
            />
          </div>
          <a class="uploadImg img-box" @click.prevent="toggleShow">
            <i class="material-icons notranslate"> cloud_upload </i>
            {{ $t("LogoImage") }}
          </a>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            class="mb-2 submit-btn bg_l_green float-right mr-4"
            @click.prevent="submitForm"
            :disabled="disableSubmit"
            v-has-permission="permission63"
            >{{ $t("Submit") }}</vs-button
          >
          <router-link
            :to="{ path: '/SaleContracts/Index' }"
            class="vs-component vs-button back-btn"
            color="rgb(62, 201, 214)"
            type="filled"
          >
            {{ $t("BackToList") }}
          </router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.uploader-box {
  min-height: 226px;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../../config";
import { mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import myUpload from "vue-image-crop-upload";
import "../../../../assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    contractTitle: {
      required: "لطفا نام قرارداد را وارد نمایید.",
    },
    cType: {
      required: "لطفا نوع قرارداد را انتخاب نمایید.",
    },
    startDate: {
      required: "لطفا تاریخ شروع قرارداد را انتخاب نمایید.",
    },
    endDate: {
      required: "لطفا تاریخ پایان قرارداد را انتخاب نمایید.",
    },
    allowedIncrease: {
      required: "مقدار افزایش مجاز را وارد کنید.",
    },
    allowedReduction: {
      required: "مقدار کاهش مجاز را وارد کنید.",
    },
    toleranceType: {
      required: "نوع تغییرات را وارد کنید.",
    },
    tax: {
      regex: "مقدار وارد شده مجاز نمی باشد",
    },
  },
};
Validator.localize("fa", dict);

export default {
  name: "saleManagement_Contract_Management_BasicInfo",
  data() {
    return {
      permission63: "ModifyContract",
      contractId: "",
      valueIsRequired: false,
      contractDetails: {
        reductionIncrease: {
          toleranceType: null,
          allowedReduction: null,
          allowedIncrease: null,
        },
      },
      contractDetailsModel: {},
      toleranceTypes: [
        { id: 0, title: "-" },
        { id: 1, title: "درصدی" },
        { id: 2, title: "مقداری" },
      ],
      disableSubmit: false,
      contractType: [
        { name: "فروش داخلی", id: 0 },
        { name: "فروش وبسایت", id: 1 },
        { name: "فروش نمایندگان", id: 2 },
        { name: "فروش سازمانی", id: 3 },
        { name: "فروش مستقیم", id: 4 },
      ],
      contractState: [{ name: "PendingState", id: 0 }],
      showUploader: false,
      URLS_CONSTANTS: URLS_CONSTANTS,
    };
  },
  components: {
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
    "my-upload": myUpload,
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters({
      contract: "sale/details",
      loading: "sale/loading",
    }),
  },
  methods: {
    ...mapActions({
      fetchSingle: "sale/fetchSingle",
      updateContract: "sale/updateContract",
    }),
    load() {
      var id = this.$route.params.id;
      this.contractId = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.contractDetails = Object.assign({}, this.contract);
        if (!this.contractDetails.reductionIncrease) {
          this.contractDetails.reductionIncrease = {
            toleranceType: null,
            allowedReduction: null,
            allowedIncrease: null,
          };
        }
      });
    },
    submitForm() {
      debugger;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disableSubmit = true;
          this.createModelForModify();
          this.updateContract(this.contractDetailsModel)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
            })
            .then((this.disableSubmit = false));
        }
      });
    },
    createModelForModify() {
      this.contractDetailsModel = {
        id: this.contractDetails.id,
        title: this.contractDetails.title,
        logoImage: this.contractDetails.logoUrl,
        startClock: this.contractDetails.startClock,
        expireClock: this.contractDetails.expireClock,
        valueAddedTax: this.contractDetails.valueAddedTax,
        toleranceType: this.contractDetails.reductionIncrease.toleranceType,
        allowedReduction:
          this.contractDetails.reductionIncrease.allowedReduction,
        allowedIncrease: this.contractDetails.reductionIncrease.allowedIncrease,
        salesType: this.contractDetails.salesType,
      };
    },
    cropSuccess(imgDataUrl) {
      this.contractDetails.logoImage = imgDataUrl;
    },
    toggleShow() {
      this.showUploader = !this.showUploader;
    },
  },
};
</script>
